import { ResourceType, RawCollection } from '../types';
import { addItemToCollectionCache } from './addItemToCollectionCache';
import { removeItemFromCollectionCache } from './removeItemFromCollectionCache';
import { OptimisticUpdater, RollbackFn } from './types';
import { getOptimisticId } from './utils';

interface OptimisticallyAddToCollectionProps {
    collectionId: string;
    resourceType: ResourceType;
    resourceId: string;
}

/**
 * Optimistically adds a resource to a collection.
 * Returns a rollback function to be used in case of an error.
 */
export const optimisticallyAddToCollection: OptimisticUpdater<OptimisticallyAddToCollectionProps> = (
    queryClient,
    { collectionId, resourceType, resourceId }
): RollbackFn => {
    const newItem = { id: getOptimisticId(), resourceId, resourceType };

    queryClient?.setQueriesData(['collections'], (oldData: RawCollection[] | undefined) => {
        if (!oldData) {
            return oldData;
        }

        return addItemToCollectionCache(oldData, { collectionId, item: newItem }).newData;
    });

    const rollback = () => {
        queryClient.setQueriesData(['collections'], (oldData: RawCollection[] | undefined) => {
            if (!oldData) {
                return oldData;
            }

            return removeItemFromCollectionCache(oldData, { itemId: newItem.id, collectionId }).newData;
        });
    };

    return rollback;
};
